module.exports = __webpack_public_path__ + "img/A3F3.9b0363cb.jpg";